import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vendorStatus'
})
export class VendorStatusPipe implements PipeTransform {

  private map: any = {
    unpaid: { label: 'Unpaid', class: 'chip-unpaid' },
    awaiting_approval: { label: 'Awaiting Approval', class: 'chip-awaiting-approval' },
    paid: { label: 'Paid', class: 'chip-paid' },
    partially_paid: { label: 'Partially Paid', class: 'chip-partially-paid' },
    rejected: { label: 'Rejected', class: 'chip-rejected' },
    added_to_payment_list: { label: 'Added to Payment List', class: 'chip-added' },
    submitted_for_payment: { label: 'Submitted for Payment', class: 'chip-submitted' },
    submitted_for_part_payment: { label: 'Submitted for Part Payment', class: 'chip-partial-submit' },
    draft: { label: 'Draft', class: 'chip-draft' },
    unverified: { label: 'Draft', class: 'chip-draft' },
    fully_outstanding: { label: 'Fully Outstanding', class: 'chip-fully-outstanding' },
  };

  transform(value: string, type: 'label' | 'class'): string {
    return this.map[value]?.[type] || '';
  }

}
